import { createGetFetchOptions } from './create-get-fetch-options';

export async function fetchGetWithRetry(url: string, cookieHeader: string): Promise<Response> {
  try {
    return await fetch(url, createGetFetchOptions({ cookieHeader }));
  } catch {
    return fetch(url, createGetFetchOptions({ cookieHeader }));
  }
}
